/** TODO: use the enum from @fe/core */
export enum FilterGroupType {
    airport,
    airspace,
    airway,
    fix,
    flightServiceStation,
    holdingPattern,
    navaid,
    sid,
    star,
    sua,
    weatherStation
}
